export default __webpack_public_path__ + "static/licence-NT-front-788b38de9396c58183b71a8e2fe3bee7.svg";